// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"984":"cf58fd","3358":"35940d"}[chunkId] + ".css";
};